<template>
  <div id="firefighter" style="text-align:center;">
    <img class="fire_pc_main" src="../assets/img/firefighter/firefighter_main2.jpg" style="width:100%;" alt="">
    <img class="fire_mo_main" src="../assets/img/firefighter/fire_main_mo.jpg" style="width:100%;" alt="">
      <img class="fire_one" src="../assets/img/firefighter/fire_one.png" alt="">
    
    <div class="fire_pink_bg">
      <div class="fire_pink_bg_under">
        <img class="fire_two" src="../assets/img/firefighter/fire_two2.jpg" alt="">
        <img class="fire_fighter" src="../assets/img/firefighter/fighter.png">
      </div>
     </div>
     <img class="fire_title1" src="../assets/img/firefighter/title2.png" alt="">
     <div id="fire_under_bt" class="fire_bt2">
        <a href="https://naver.me/xGINNypJ" >참여하기</a>

      </div>
     


     <div class="fire_line"></div>

    <div class="fire_prodt_bg" >
      <div class="fire_hokkaido" >
        <div class="fire_title_left">
          <img class="title_left" src="../assets/img/firefighter/hk_title.jpg" alt="">
        </div>
        

        <div class="fire_pr_img">
          <img src="../assets/img/firefighter/hk_biei.png" @click="goToDetail('L-202346-1680743217094', 'L')" alt="">
        <img class="pr_img_midle" src="../assets/img/firefighter/hk_nobo.png" @click="goToDetail('L-2431993LGC', 'L')" alt="">
        <img src="../assets/img/firefighter/hk_shako1.png" @click="goToDetail('L-2023317-1679040615952', 'L')" alt="">
        </div>

        <div class="fire_pr_img">
          <img src="../assets/img/firefighter/hk_shako2.png" @click="goToDetail('L-2532498BLC', 'L')" alt="">
        <img class="pr_img_midle" src="../assets/img/firefighter/hk_hhk.png" @click="goToDetail('L-20231019-1697704655687', 'L')" alt="">
        <img src="../assets/img/firefighter/hk_maru.png" @click="goToDetail('L-24111959ZCC', 'L')" alt="">
        </div>

        <div class="fire_pr_img nika_left">
          <img  src="../assets/img/firefighter/hk_nika.png" @click="goToDetail('L-2432173MCC', 'L')" alt="">
        </div>
      </div>
    </div>
      <div class="fire_line"></div>

      <div class="fire_prodt_bg" >
      <div class="fire_hokkaido" >
        <div class="fire_title_left">
          <img class="title_left" src="../assets/img/firefighter/hs_title.jpg" alt="">
        </div>
        

        <div class="fire_pr_img" >
          <img src="../assets/img/firefighter/hs_kyoto.png" @click="goToDetail('L-2023220-1676865317720', 'L')" alt="">
        <img class="pr_img_midle" src="../assets/img/firefighter/hs_nagoya.png" @click="goToDetail('L-2023221-1676943535719', 'L')"  alt="">
        <img src="../assets/img/firefighter/hs_tokyo.png" @click="goToDetail('L-2023329-1680070456245', 'L')" alt="">
        </div>
    </div>
    </div>

    <div class="fire_line"></div>

    <div class="fire_prodt_bg">
      <div class="fire_hokkaido">
        <div class="fire_title_left">
          <img class="title_left" src="../assets/img/firefighter/ks_title2.jpg" alt="">
        </div>
        

        <div class="fire_pr_img" style="margin-bottom: 80px;">
          <img src="../assets/img/firefighter/ks_aso.png" @click="goToDetail('L-2023221-1676942590519', 'L')" alt="">
        <img class="pr_img_midle" src="../assets/img/firefighter/ks_yufu.png" @click="goToDetail('L-2025324-1742803712116', 'L')"  alt="">
        <img src="../assets/img/firefighter/ks_yama.png" @click="goToDetail('L-2024312-1710224515956', 'L')" alt="">
        </div>
        <div class="fire_pr_img" style="text-align:left;">
          <img src="../assets/img/firefighter/ks_takachi.png" @click="goToDetail('L-20241122-1732249762453', 'L')" alt="">
        </div>
    </div>
    </div>

    <div class="fire_line"></div>
    <div class="fire_prodt_bg">
      <div class="fire_hokkaido">
        <div style="text-align:left;">
          <img class="title_left" src="../assets/img/firefighter/sk_title.jpg" alt="">
        </div>
        
        <div class="fire_pr_img" style="text-align:left;">
          <img src="../assets/img/firefighter/shikoku_mas.png" @click="goToDetail('L-24112101RNC', 'L')" alt="">
        </div>
    </div>
    </div>


    <div id="fire_under_bt" class="fire_bt">
        <a href="https://naver.me/xGINNypJ" >참여하기</a>

      </div>
  </div>
</template>

<script>

import defaultPath from '@/assets/img/taiwan/back.jpg';

export default {
  // DB에서 가져온 데이타
  data() {
    return {
      //imagePath: "/IMGs/testtaiwan/back.jpg"   //상단이미지 default
      imagePath: defaultPath,   //상단이미지 default
      animateImage: false
    };
  },
  created() {
    this.bSeq = this.$route.query.bSeq;
    this.chkSize = window.innerWidth
    //alert(this.chkSize) 화면 사이즈 체크
  },
  // filters: {
  //   currency: function(val) {
  //     var num = new Number(val);
  //     return num.toFixed(0).replacereplace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   }
  // },
  computed: {
    user() {
      return this.$store.state.user;
    }   
  },
  methods: {
    goToDetail(productId, salesRoute) {
      this.$router.push({path: '/detail', query: {productId: productId, salesRoute:salesRoute}});
    }
  },
  mounted() {

    // //권한없는 로그인 차단
    // if(this.user.handlerGrade >= 20) {
    //   var swal = require('sweetalert2');
    //   swal.fire({
    //     title: '로그인 필요', 
    //     text: '접근권한 확인불가.',
    //     icon: 'error'
    //   });
    //   this.$router.push({path: '/'}); 
    // }

}}


</script>

<style>
@keyframes moveUpDown {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-10px); /* 위로 5px 이동 */
    }
    100% {
        transform: translateY(0);
    }
}
#firefighter{
  margin-top: -56px;
}
.fire_mo_main{
  display: none;
}
.fire_pr_img>img{
  transition: all 0.2s;
  box-shadow: 3px 3px 10px;
  width: 350px;
}

.fire_pr_img>img:hover{
  transition: all 0.2s;
  transform: translateY(-10px);
}
.firstimg{
  position: relative;
  top: 0;
  left: 0;
  z-index: 8;
}

.fire_one{
  position: relative;
  top: -100px;
    width: 40%;
}
.fire_pink_bg{
  background-color: #ff7800;
  width:100%;
  margin-top:-340px;
  text-align:center;
  padding:400px 00px 150px 0px
}
.fire_pink_bg_under{
  width:1500px;
  height:900px;
  background:#fff;
  display:inline-block;
}
.fire_two{
  margin-top: 100px; width:60%;
}
.fire_title1{
  margin:130px 0 30px;
  width:30%;
}
.fire_under{
  width: 5%;
  margin:0 auto;
  padding-bottom: 50px;
  display: block;
  animation: moveUpDown 2s infinite alternate;
}
.fire_line{
  width: 100%;
  height:50px;
  background-color: #ff7800;
}
.fire_prodt_bg{
  background-color: #fff;
  width:100%; 
  padding:150px 0 150px 0px;
  margin:0 auto;
}
.fire_hokkaido{
  width: 1200px; margin:0 auto; text-align: center;
}
.fire_title_left{
  text-align: left;
}
.title_left{
  text-align:left;
  margin-bottom:50px;
  width:80%;
}
.fire_pr_img{
  margin-bottom: 80px;
}
.pr_img_midle{
  margin:0 75px;
}
.fire_bt{
  margin:100px auto;
  text-align:center;
  width:1200px;
}
.fire_bt2{
  margin:50px auto 100px auto;
  text-align:center;
  width:1200px;
}
.fire_bt a{
  display:block;
  margin:0 auto;
  width: 300px;
  height:80px;
  border-radius:10px;
  padding-top:1.4rem;
  color:#fff;
  background-color:#ff7800;
  font-size:18pt;
  font-weight:large;
  transition: all 0.5s;
}
.fire_bt a:hover{
  color:#fff;
  background-color:#914300;
  transition: all 0.5s;
}
.fire_bt2 a{
  display:block;
  margin:0 auto;
  width: 300px;
  height:80px;
  border-radius:10px;
  padding-top:1.4rem;
  color:#fff;
  background-color:#ff7800;
  font-size:18pt;
  font-weight:large;
  transition: all 0.5s;
}
.fire_bt2 a:hover{
  color:#fff;
  background-color:#914300;
  transition: all 0.5s;
}
.nika_left{
  text-align: left;
}
.fire_fighter{
  position:absolute;
  right:0;
  bottom:-1576px;
  z-index:3;
  width:20%;
}
@media(max-width:1920px){
.fire_fighter{
  position:absolute;
  right:0;
  bottom:-1523px;
  z-index:3;
  width:20%;
}
}
@media(max-width:768px){
  .fire_one{
    top: -35px;
    width: 80%;
}

.fire_pink_bg{
  background-color: #ff7800;
  margin-top:-100px;
  padding:100px 00px 50px 0px
}
.fire_pink_bg_under{
  width:95%;
  height:calc(350px);
}
.fire_two{
  margin-top: 50px;
  width:90%;
}
.fire_fighter{
  display:none;
}
.fire_title1{
  margin:40px 0 20px;
  width:90%;
}
.fire_line{
  height:10px;
}


.fire_prodt_bg{
  background-color: #fff;
  width:100%; 
  padding:50px 0 50px 0px;
  margin:0 auto;
}
.fire_hokkaido{
  width: 95%;
  margin-left: 8%;
}
.fire_title_left{
  text-align: left;
}
.title_left{
  text-align:left;
  margin: 0%  0% 20px 0;
  width:90%;
}
.fire_pr_img{
  margin-bottom: 10px;
  width: 90%;
}
.pr_img_midle{
  margin:20px 0;
}
.fire_pr_img>img{
  width: 100%;
}
.fire_bt{
  text-align:center;
  width:100%;
  margin: 40px auto;
}
.fire_bt a{
  display:block;
  margin:0 auto;
  width: 300px;
  height:80px;
  border-radius:10px;
  padding-top:1.4rem;
  color:#fff;
  background-color:#ff7800;
  font-size:15pt;
  font-weight:600;
}
.fire_bt2{
  text-align:center;
  width:100%;
  margin: 40px auto;
}
.fire_bt2 a{
  display:block;
  margin:0 auto;
  width: 300px;
  height:80px;
  border-radius:10px;
  padding-top:1.4rem;
  color:#fff;
  background-color:#ff7800;
  font-size:15pt;
  font-weight:600;
}
#firefighter{
  margin-top: 35px;
}
.fire_pc_main{
  display: none;
}
.fire_mo_main{
  display: block;
}
}
</style>

